/** @format */

import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import FontAwesomeIcon from '@/plugins/font-awesome-icon';
import 'normalize.css';
import 'nprogress/nprogress.css';

Vue.config.productionTip = false;


// Array.prototype.chunk = function(size) {
// 	let result = [];
// 	for (let i = 0; i < this.length; i += size) {
// 		let chunk = this.slice(i, i + size);
// 		result.push(chunk);
// 	}
// 	return result;
// };

// Array.prototype.last = function() {
// 	if (this.length === 0) return [];
// 	return this.slice(-1)[0];
// };

Number.prototype.between = function(a, b) {
	let min = Math.min(a, b),
		max = Math.max(a, b);

	return this > min && this < max;
};

Vue.use(FontAwesomeIcon);

const requireComponent = require.context('./components', false, /Base[A-Z]\w+\.(vue|js)$/);

requireComponent.keys().forEach((fileName) => {
	const componentConfig = requireComponent(fileName);

	const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1')));

	Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.filter('labelised', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.replace(/_/g, ' ').replace(/\w\S*/g, function(word){
		return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
	});
})

Vue.directive('click-outside', {
	bind: function(el, binding, vnode) {
		el.clickOutsideEvent = function(event) {
			if (!(el == event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent);
	},
	unbind: function(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	}
});

new Vue({
	router,
	store,
	created() {
		const userString = localStorage.getItem('user'); // grab user data from local storage
		if (userString) {
			// check to see if there is indeed a user
			const userData = JSON.parse(userString); // parse user data into JSON
			this.$store.commit('user/SET_USER_DATA', userData); // restore user data with Vuex
		}
		axios.interceptors.response.use(
			(response) => response, // simply return the response
			(error) => {
				if (error.response.status === 401) {
					// if we catch a 401 error
					this.$store.dispatch('logout'); // force a log out
				}
				return Promise.reject(error); // reject the Promise, with the error as the reason
			}
		);
	},
	render: (h) => h(App)
}).$mount('#app');
